module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/Placeholder-fbcaddc2a739fd9c6435282c98545229.svg";